import { createSlice } from "@reduxjs/toolkit";

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    showFeedback: false,
    title: "",
    message: "",
    type: "",
  },
  reducers: {
    setFeedback: (state, action) => {
      state.showFeedback = action.payload.showFeedback;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
    clearFeedback: (state) => {
      state.showFeedback = false;
      state.title = "";
      state.message = "";
      state.type = "";
    },
  },
});

export const { setFeedback, clearFeedback } = feedbackSlice.actions;
export default feedbackSlice.reducer;
